import { SIGNIN_ACTION } from '@glass/web/modules/auth/authActionTypes';
import { LOADING_AUTH_VIEW } from '@glass/web/modules/authForm/authViews';

// eslint-disable-next-line import/no-cycle
import promptAuthAction from '@glass/shared/modules/authForm/actions/promptAuthAction';

const setAuthLoadingAction = (options = {}) =>
  promptAuthAction({
    ...options,
    inDialog: true,
    actionType: SIGNIN_ACTION,
    view: LOADING_AUTH_VIEW,
  });

export default setAuthLoadingAction;
